module.exports = __webpack_public_path__ + "static/media/centivo-logo.1dfdd461.svg";